// extracted by mini-css-extract-plugin
module.exports = {"attForm":"styles_attForm__2ilTm","item":"styles_item__2GDlZ"};